import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
    //NOTE: Do not pass the keyword "type" as an argument, as it will override the action type name.
    getSupplier: [],
    getSupplierSuccess: ['supplier'],
    getSupplierFailure: ['getSupplierError'],

    createSupplier: ['email', 'supplierId'],
    createSupplierSuccess: ['supplier'],
    createSupplierFailure: [],

    updateSupplier: ['body', 'callback'],
    updateSupplierSuccess: ['supplier'],
    updateSupplierFailure: ['updateSupplierError'],

    reauthenticateSupplier: ['supplierId', 'window'],
    reauthenticateSupplierSuccess: ['url'],
    reauthenticateSupplierFailure: [],
    reauthenticateSupplierLoading: [],

    resetProfileForTests: ['callback'],

    getShopifyDetails: ['supplierId'],
    getShopifyDetailsSuccess: ['shopifyDetails'],
    getShopifyDetailsFailure: ['shopifyDetailsError'],

    getShopifyProducts: ['supplierId'],
    getShopifyProductsSuccess: ['shopifyProducts'],
    getShopifyProductsFailure: ['shopifyProductsError'],

    getShopifyProductsCount: ['supplierId'],
    getShopifyProductsCountSuccess: ['shopifyProductsCount'],
    getShopifyProductsCountFailure: ['shopifyProductsCountError'],

    updateShopifyDetails: ['body', 'callback'],
    updateShopifyDetailsSuccess: [],
    updateShopifyDetailsFailure: ['shopifyDetailsError'],

    removeShopifyDetails: ['supplierId', 'callback'],
    removeShopifyDetailsSuccess: [],
    removeShopifyDetailsFailure: ['removeShopifyDetailsError'],
})

export const SupplierTypes = Types

const INITIAL_STATE = {
    loadingGetSupplier: false,
    supplier: {},
    getSupplierError: null,
    loadingCreateSupplier: false,
    loadingReauthenticateSupplier: false,
    loadingUpdateSupplier: false,
    updateSupplierError: null,

    loadingGetShopifyProducts: false,
    shopifyProducts: [],
    shopifyProductsError: null,

    loadingGetShopifyProductsCount: false,
    shopifyProductsCount: null,
    shopifyProductsCountError: null,

    loadingUpdateShopifyDetails: false,

    loadingGetShopifyDetails: false,
    shopifyDetails: {},
    shopifyDetailsError: null,

    loadingRemoveShopifyDetails: false,
    removeShopifyDetailsError: null,
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_SUPPLIER]: state => ({
        ...state,
        loadingGetSupplier: true,
    }),
    [Types.GET_SUPPLIER_SUCCESS]: (state, { supplier }) => ({
        ...state,
        supplier,
        loadingGetSupplier: false,
        getSupplierError: null,
    }),
    [Types.GET_SUPPLIER_FAILURE]: (state, { getSupplierError }) => ({
        ...state,
        loadingGetSupplier: false,
        getSupplierError,
    }),

    [Types.CREATE_SUPPLIER]: state => ({
        ...state,
        loadingCreateSupplier: true,
    }),
    [Types.CREATE_SUPPLIER_SUCCESS]: (state, { supplier }) => ({
        ...state,
        supplier,
        loadingCreateSupplier: false,
    }),
    [Types.CREATE_SUPPLIER_FAILURE]: state => ({
        ...state,
        loadingCreateSupplier: false,
    }),
    // updateSupplierError
    [Types.UPDATE_SUPPLIER]: state => ({
        ...state,
        loadingUpdateSupplier: true,
    }),
    [Types.UPDATE_SUPPLIER_SUCCESS]: (state, { supplier }) => ({
        ...state,
        supplier: { ...state.supplier, ...supplier },
        loadingUpdateSupplier: false,
        updateSupplierError: null,
    }),
    [Types.UPDATE_SUPPLIER_FAILURE]: (state, { updateSupplierError }) => ({
        ...state,
        loadingUpdateSupplier: false,
        updateSupplierError,
    }),

    [Types.REAUTHENTICATE_SUPPLIER]: state => ({
        ...state,
        loadingReauthenticateSupplier: true,
    }),
    [Types.REAUTHENTICATE_SUPPLIER_SUCCESS]: state => ({
        ...state,
        loadingReauthenticateSupplier: true,
    }),
    [Types.REAUTHENTICATE_SUPPLIER_FAILURE]: state => ({
        ...state,
        loadingReauthenticateSupplier: false,
    }),
    [Types.REAUTHENTICATE_SUPPLIER_LOADING]: state => ({
        ...state,
        loadingReauthenticateSupplier: true,
    }),
    [Types.RESET_PROFILE_FOR_TESTS]: state => state,

    // Get Shopify details
    [Types.GET_SHOPIFY_DETAILS]: state => ({ ...state, loadingGetShopifyProducts: true }),
    [Types.GET_SHOPIFY_DETAILS_SUCCESS]: (state, { shopifyDetails }) => ({
        ...state,
        loadingGetShopifyDetails: false,
        shopifyDetails,
        shopifyDetailsError: null,
    }),
    [Types.GET_SHOPIFY_DETAILS_FAILURE]: (state, { shopifyDetailsError }) => ({
        ...state,
        loadingGetShopifyDetails: false,
        shopifyDetails: {},
        shopifyDetailsError,
    }),

    // Get Shopify products
    [Types.GET_SHOPIFY_PRODUCTS]: state => ({ ...state, loadingGetShopifyProducts: true }),
    [Types.GET_SHOPIFY_PRODUCTS_SUCCESS]: (state, { shopifyProducts }) => {
        return {
            ...state,
            loadingGetShopifyProducts: false,
            shopifyProducts,
            shopifyProductsError: null,
        }
    },
    [Types.GET_SHOPIFY_PRODUCTS_FAILURE]: (state, { shopifyProductsError }) => ({
        ...state,
        loadingGetShopifyProducts: false,
        shopifyProducts: [],
        shopifyProductsError,
    }),

    // Get Shopify products count
    [Types.GET_SHOPIFY_PRODUCTS_COUNT]: state => ({ ...state, loadingGetShopifyProductsCount: true }),
    [Types.GET_SHOPIFY_PRODUCTS_COUNT_SUCCESS]: (state, { shopifyProductsCount }) => ({
        ...state,
        loadingGetShopifyProductsCount: false,
        shopifyProductsCount,
        shopifyProductsCountError: null,
    }),
    [Types.GET_SHOPIFY_PRODUCTS_COUNT_FAILURE]: (state, { shopifyProductsCountError }) => ({
        ...state,
        loadingGetShopifyProductsCount: false,
        shopifyProductsCount: null,
        shopifyProductsCountError,
    }),

    // store suppliers Shopify details
    [Types.UPDATE_SHOPIFY_DETAILS]: state => ({ ...state, loadingUpdateShopifyDetails: true }),
    [Types.UPDATE_SHOPIFY_DETAILS_SUCCESS]: state => ({ ...state, loadingUpdateShopifyDetails: false }),
    [Types.UPDATE_SHOPIFY_DETAILS_FAILURE]: state => ({ ...state, loadingUpdateShopifyDetails: false }),

    // removeShopifyDetails
    [Types.REMOVE_SHOPIFY_DETAILS]: state => ({ ...state, loadingRemoveShopifyDetails: true }),
    [Types.REMOVE_SHOPIFY_DETAILS_SUCCESS]: state => ({
        ...state,
        loadingRemoveShopifyDetails: false,
        removeShopifyDetailsError: null,
        shopifyDetails: {},
    }),
    [Types.REMOVE_SHOPIFY_DETAILS_FAILURE]: (state, { removeShopifyDetailsError }) => ({
        ...state,
        loadingRemoveShopifyDetails: false,
        removeShopifyDetailsError,
    }),
})

export default Creators
